import { removeCurrentUser } from 'helpers/storage'
import { removeUserInfo } from 'hooks/userInfo'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const LoginRedirect = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	useEffect(() => {
		removeCurrentUser()
		dispatch(removeUserInfo())
		navigate('/')
	}, [])

	return <div></div>
}

export default LoginRedirect
